export default __webpack_public_path__ + "static/bg-2-d96b9b31be29c26257aa5362fd9cd75b.png";